const convertTime = (time) => {
  const hours = Math.floor(time / 3600);
  time %= 3600;
  const minutes = Math.floor(time / 60);
  time %= 60;
  const seconds = Math.floor(time);
  let convertedTime = '';
  if (hours>0) convertedTime = hours+'h:';
  if (minutes>0) {
    if (hours>0 && minutes.toString().length === 1) {
      convertedTime += '0'+minutes+'m:';
    } else {
      convertedTime += minutes+'m:';
    }
  }
  if (seconds>0) {
    if ((hours>0 || minutes>0) && seconds.toString().length === 1) {
      convertedTime += '0'+seconds+'s';
    } else {
      convertedTime += seconds+'s';
    }
  }
  // remove colon if it's the last character
  convertedTime = convertedTime.replace(/:$/, '');
  return convertedTime;
};
export {convertTime};


// WEBPACK FOOTER //
// ./src/functions/convertTime.js